<template>
  <div class="avue-contail" :class="{ 'avue--collapse': isCollapse }">
    <div class="avue-header">
      <!-- 顶部导航栏 -->
      <top />
    </div>

    <div class="avue-layout">
      <div class="avue-left">
        <!-- 左侧导航栏 -->
        <sidebar />
      </div>
      <div class="avue-main">
        <!-- 顶部标签卡 -->
        <tags />
        <!-- 主体视图层 -->
        <el-scrollbar style="height: calc(100% - 40px)">
          <div id="app" class="content">
            <div class="backTop" ref="scrollview">
              <keep-alive>
                <router-view class="avue-view" v-if="$route.meta.$keepAlive" />
              </keep-alive>
              <router-view class="avue-view" v-if="!$route.meta.$keepAlive" />
              <el-backtop
                target=".content .backTop"
                :bottom="100"
                :visibility-height="50"
              >
                <div
                  style="
                     {
                      height: 100%;
                      width: 100%;
                      background-color: #f2f5f6;
                      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                      text-align: center;
                      line-height: 40px;
                      color: #1989fa;
                    }
                  "
                >
                  UP
                </div>
              </el-backtop>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="avue-shade" @click="showCollapse"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tags from './tags';
import top from './top/';
import sidebar from './sidebar/';
import admin from '@/util/admin';
import { validatenull } from '@/util/validate';
import { calcDate } from '@/util/date.js';
import { getStore } from '@/util/store.js';

export default {
  components: {
    top,
    tags,
    sidebar,
  },
  name: 'index',
  data() {
    return {
      //刷新token锁
      refreshLock: false,
      //刷新token的时间
      refreshTime: '',
      scroll: 0,
    };
  },
  created() {
    //实时检测刷新token
    this.refreshToken();
  },
  beforeDestroy() {
    clearInterval(this.refreshTime);
    const scrollview = this.$refs['scrollview'];
    // 添加滚动监听，该滚动监听了拖拽滚动条
    // 尾部的 true 最好加上，我这边测试没加 true ，拖拽滚动条无法监听到滚动，加上则可以监听到拖拽滚动条滚动回调
    scrollview &&
      scrollview.removeEventListener('scroll', this.scrollChange, true);
  },
  mounted() {
    this.init();
    // 获取指定元素
    const scrollview = this.$refs['scrollview'];
    // 移除监听

    scrollview.addEventListener('scroll', this.scrollChange, true);
  },
  computed: mapGetters([
    'userInfo',
    'isLock',
    'isCollapse',
    'website',
    'expires_in',
  ]),
  props: [],
  methods: {
    //滚动事件
    scrollChange(e) {
      this.scroll = this.$refs.scrollview.scrollTop;
      // console.log('父滚动条到页面顶部距离', e.target.offsetTop)
      // console.log('相对距离', this.$refs.scrollview.scrollTop)
      // console.log('绝对距离', e.target.offsetTop + this.$refs.scrollview.scrollTop)
    },
    showCollapse() {
      this.$store.commit('SET_COLLAPSE');
    },
    // 屏幕检测
    init() {
      this.$store.commit('SET_SCREEN', admin.getScreen());
      window.onresize = () => {
        setTimeout(() => {
          this.$store.commit('SET_SCREEN', admin.getScreen());
        }, 0);
      };
    },
    // 实时检测刷新token
    refreshToken() {
      this.refreshTime = setInterval(() => {
        const token = getStore({
          name: 'access_token',
          debug: true,
        });

        if (validatenull(token)) {
          return;
        }

        if (this.expires_in <= 1000 && !this.refreshLock) {
          this.refreshLock = true;
          this.$store.dispatch('RefreshToken').catch(() => {
            clearInterval(this.refreshTime);
          });
          this.refreshLock = false;
        }
        this.$store.commit('SET_EXPIRES_IN', this.expires_in - 10);
      }, 10000);
    },
  },
};
</script>
<style lang="scss" scoped>
html,
body {
  height: 100%;
}
.content {
  height: 100%;
}
.backTop {
  overflow-y: auto;
  height: 100%;
}
</style>
